<template>
	<div id="dlog" class="modal z-depth-modified--1" ref="dlog" v-if="active">
		<div class="modal-content">
			<div class="modal-title">
				<slot name="title"></slot>
			</div>
			<slot></slot>
		</div>
		<div class="modal-footer">
			<button
				v-for="button in buttons"
				v-bind:key="button.id"
				@click="button.action"
				v-bind:class="[{'modal-close':button.close }, 'actions btn-flat z-depth-0 waves-effect close-modal']"
			>{{button.value}}</button>
		</div>
	</div>
</template>
<style>
</style>

<script>
import store from '@/store.js'
export default {
  name: "dialogComponent",
  props:{
    buttons:{
      type: [Array, Object]
    },
    domProps:{
      type:String,
    }
  },
	data() {
		return {
			store,
			btns: [],
			me: "",
			active: true,
			Modal:{
				instance: null,
				options:{
					opacity:.3,
					dismissible: false,
					onCloseEnd:()=>{
						this.active = !1;
					},
					onOpenEnd:()=>{
					},
					preventScrolling:false,
					startingTop:'40%',
					endingTop:'40%',
				}
			},
		};
	},
		watch: {
    'store.state.dialog.active':function(nV) {
			if(!nV) this.Modal.instance.close()
    }
	},
	mounted() {
		setTimeout(() => {
			this.runModalEvent();
		}, 100);
	},
	methods: {
		runModalEvent() {
				// eslint-disable-next-line
			this.Modal.instance = M.Modal.init(this.$refs.dlog, this.Modal.options)
			this.Modal.instance.open()
		}
	}
};
</script>
<style scoped lang="scss">
#dlog {
	max-width: 350px;
	&.modal {
			border-radius: 8px;
		}
	.modal-title {
		font-size: 18px;
		font-weight: 500;
		text-transform: capitalize;
	}
}
</style>
<style>
.showMe {
	z-index: 1003 !important;
}
</style>
